import React, {memo} from "react";
//local
import {hasTranslation} from "helpers/helper";
import cn from "classnames";

export const SubscriptionMainInfo = memo(({subscription, options, isActive, t}) => (
  <React.Fragment>
    <div className={cn("df-column-start", {__active: !isActive})}>
      {subscription.icon}
      <h3 className={cn("subscription__title", {__active: !isActive})}>
        {t(subscription.name)}
      </h3>
      <span className="subscription__description">{t(subscription.descriptionKey)}</span>
    </div>

    <ul className={cn("subscription__options", {__active: !isActive})}>
      {!!options?.length &&
        options
          .filter((item) => hasTranslation(item))
          .map((item) => (
            <li className="subscription__option" key={item}>
              <span>{t(item)}</span>
            </li>
          ))}
    </ul>
  </React.Fragment>
));
